export const radius = {
  sm: "5px",
  md: "7px",
  lg: "10px",
};
